// src/LegalPage.js
import React from "react";

export default function LegalPage({ onBack }) {
  return (
    <div style={{ fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
      <div
        style={{
          maxWidth: 900,
          margin: "32px auto",
          padding: "24px 20px 40px",
        }}
      >
        <button
          onClick={onBack}
          style={{
            marginBottom: 24,
            padding: "8px 14px",
            borderRadius: 999,
            border: "1px solid #e2e8f0",
            background: "#ffffff",
            cursor: "pointer",
            fontSize: 14,
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <span>←</span>
          <span>Back to app</span>
        </button>

        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Terms of Service &amp; Privacy Policy</h1>
        <p style={{ color: "#64748b", marginBottom: 24 }}>
          This page describes the terms you agree to when using this application and how we handle your data.
        </p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>1. Terms of Service</h2>
          <p style={{ marginBottom: 12 }}>
            By creating an account or using this application, you agree to use it only for lawful purposes and in
            accordance with these Terms. You are responsible for maintaining the confidentiality of your account and
            for all activities that occur under your account.
          </p>
          <p style={{ marginBottom: 12 }}>
            The application and all content are provided &quot;as is&quot; without warranties of any kind. We do not
            guarantee accuracy, completeness, or fitness for a particular purpose, and you use the application at your
            own risk.
          </p>
          <p style={{ marginBottom: 12 }}>
            We may update or change the application and these Terms from time to time. Continued use after changes
            become effective constitutes acceptance of the updated Terms.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>2. Data &amp; Privacy</h2>
          <p style={{ marginBottom: 12 }}>
            When you sign up or sign in, we process your authentication data via our identity provider (Clerk). This
            typically includes your name, email address, and basic profile information required to operate the service.
          </p>
          <p style={{ marginBottom: 12 }}>
            We may store usage data (such as feature usage, timestamps, and technical logs) to monitor performance,
            improve the product, and ensure the security of the service.
          </p>
          <p style={{ marginBottom: 12 }}>
            We do not sell your personal data. We may share data with service providers who support the application
            (for example, hosting, analytics, or authentication providers) under appropriate safeguards.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>3. AI &amp; No Financial Advice</h2>
          <p style={{ marginBottom: 12 }}>
            Parts of this application use AI-generated estimates, forecasts, or explanations. AI may produce incorrect,
            incomplete, or outdated information. All outputs are for informational and experimental purposes only.
          </p>
          <p style={{ marginBottom: 12 }}>
            Nothing in this application constitutes financial, investment, legal, or tax advice. You are solely
            responsible for any decisions you make. Always independently verify any results and consult a qualified
            professional before making real-world, financial, or investment decisions.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>4. Contact</h2>
          <p style={{ marginBottom: 4 }}>
            If you have questions about these Terms or our data practices, you can contact us at:
          </p>
          <p style={{ fontWeight: 600 }}>AlgoreitAI@gmail.com</p>
        </section>
      </div>
    </div>
  );
}


